import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { getAcApiUrl } from "@tw/shared-ui-components/lib/utils/helper";

export const enums = {
  SET_LOGIN_STATE: { type: "SET_LOGIN_STATE", state: "login" },
  SET_LOGIN_INFO_STATE: { type: "SET_LOGIN_INFO_STATE", state: "info" },
};

// COMMON FETCH & SET STATE FUNCTIONS -->
export const setState = (type, state) => {
  return {
    type: type.type,
    payload: state,
  };
};
// <--

export const setLoginState = state => {
  //console.warn('setLoginState')
  return setState(enums.SET_LOGIN_STATE, state);
};

export const fetchLoginState = cookies => async dispatch => {
  let user = {};

  if (cookies) {
    user.ada = cookies.ada;
    user.role = cookies.role;
    user.accessToken = cookies.accessToken;
    user.loginType = cookies.loginType;
    user.loginMemberType = cookies.loginMemberType;
    user.isGuest = cookies.isGuest;
    //user.idToken = cookies.idToken;
    user.user = typeof cookies.user === "string" ? JSON.parse(cookies.user) : cookies.user;
  }

  dispatch(setState(enums.SET_LOGIN_STATE, user));
};

export const fetchInfoState = login => async dispatch => {
  try {
    const apiUrl = getAcApiUrl();
    const res = await axios({
      headers: {
        Authorization: "Bearer " + login.token.accessToken,
      },
      method: "post",
      url: `${apiUrl}/profile`,
      data: {
        personalId: login.usersInfo[0].personalId,
        loginAda: login.ada,
        loginInfo: true,
      },
    });
    dispatch(setState(enums.SET_LOGIN_INFO_STATE, res.data));
    return res.data;
  } catch (err) {
    console.log(err);
  }
  return "error";
};

const loginState = (state = {}, action) => {
  switch (action.type) {
    // for special case

    // for use enum
    default:
      if (enums[action.type]) {
        return {
          ...state,
          [enums[action.type].state]: action.payload,
        };
      }

      // for default
      return state;
  }
};

export default {
  loginState,
};
